<template>
	<div class="ticket-book">
		<div class="ticket-book-step">
			<div class="active">
				<label>1.填写订单信息</label>
				<div class="tb-step-pg"></div>
			</div>
			<div >
				<label>2.选择付款方式付款</label>
				<div class="tb-step-pg"></div>
			</div>
			<div >
				<label>3.预订成功</label>
				<div class="tb-step-pg"></div>
			</div>
		</div>
		<div class="ticket-book-content">
			<div class="ticket-bc-box">
				<div class="ticket-bc-head">
					{{ticketBookInfo.ScenicName}}(在线支付)
				</div>
				<div class="ticket-bc-list">
					<div class="ticket-bc-item">
						<label>游玩日期</label>
						<div class="ticket-date-select" @click="isDateShow=!isDateShow">
							<i class="iconfont icon-calendar"></i>
							<label v-if="mySelect">{{mySelect.PriceDate|dateToYMDline}}</label>
                            <label v-else>请选择日期</label>
						</div>
                        <DailyData :dailyData="dailyData" @selectday="selectday" v-if="isDateShow"></DailyData>
					</div>
					<div class="ticket-bc-item">
						<label class="veralTop">预订数量</label>
						<div class="ticket-bc-table">
							<table>
								<thead> 
									<tr>
										<th width="70%">
											商品名称
										</th>
										<th>
											订房易价
										</th>
										<th>
											数量 
                                            <span class="ticket-max-info">(最多可购{{ticketBookInfo.Maximum-mySelect.Stock>0?mySelect.Stock:ticketBookInfo.Maximum}}张)</span>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<span class="name">{{ticketBookInfo.TicketName}}</span>
										</td>
										<td>
											<span class="cur">￥</span>
                                            <span class="cur" v-if="!mySelect">请先选择日期</span>
											<span class="price" v-else>{{mySelect.Price}}</span>
										</td>
										<td>
											<div class="ticket-count">
												<div class="plus" @click="minus">-</div>
												<span>{{stock}}</span>
												<div class="minu" @click="plus">+</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="ticket-bc-info">
								<div class="ticket-bci-item">
									<label>费用包含</label>
									<div>
										<p>{{ticketBookInfo.CostInclude||'无'}}</p>
									</div>
								</div>
								<div class="ticket-bci-item">
									<label>入园须知</label>
									<div>
										<p>{{ticketBookInfo.Explanation||'无'}}</p>
									</div>
								</div>
								<div class="ticket-bci-item">
									<label>重要提示</label>
									<div>
										<p>1.  为了您人身、财产的安全，请您避免在公开场合暴露贵重物品及大量现金。上街时需时刻看管好首饰、相机等随身物品。</p>
            							<p>2.  游泳、漂流、潜水、滑雪、滑冰、戏雪、热气球、跳伞、浮潜、摩托艇、滑翔伞、动力伞、攀岩等活动项目，均存在危险。参与前请根据自身条件，并充分参考当地相关部门及其它专业机构的相关公告和建议后量力而行。请您在预订前阅读驴妈妈为您整理各项高风险活动的 <label class="book-notice" @click="isRullShow=!isRullShow">《安全须知》</label></p>
                                        <Rull v-show="isRullShow"></Rull>
									</div>
								</div>
								<div class="ticket-bci-item">
									<label>退改说明</label>
									<div>
										<p>{{ticketBookInfo.RegressionRule||'无'}}</p>
									</div>
								</div>

							</div>
							<div class="ticket-bc-total">
								<label>门票总价：</label>
								<span v-if="mySelect">¥{{mySelect.Price*stock}} </span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="ticket-bc-box">
				<div class="ticket-bc-head">
					用户信息

                    <label class="order-customer-limit-info" v-if="!isOnlyOneNeed&&Guests.length>=1">
                        需要<span>{{Guests.length+1}}</span>位出行游客信息
                    </label> 
                    <label class="order-customer-limit-info" v-else>
                        仅需要<span>1位</span>出行游客信息
                    </label>
				</div>
				<div class="ticket-bc-text">
					<div class="ticket-bct-item">
						<label>*姓名</label>
						<div>
							<input type="text" name="" placeholder="需与证件保持一致" v-model="PickUpName" />
						</div>
					</div>
					<div class="ticket-bct-item" >
						<label>*手机号码</label>
						<div>
							<input type="text" name="" placeholder="接收取票短信凭证" v-model="PickUpPhone" />
						</div>
					</div>
                    <div class="ticket-bct-item" v-if="ticketBookInfo.TravellerEmail>0">
                        <label>E-mail</label>
                        <div>
                            <input type="text" name=""  placeholder="邮箱" v-model="PickUpEmail" />
                        </div>
                    </div>
					<div class="ticket-bct-item">
						<label>*图片验证码</label>
						<div>
							<input type="text" name="" v-model="CaptchaCode" />
                            <img :src="codeImg" @click="getCaptcha" class="ticket-bct-item-captcha">
						</div>
					</div>
					<div class="ticket-bct-item" v-if="ticketBookInfo.TravellerCredentialsType>0">
						<label>*证件类型</label>
						<div>
							<select>
								<option>身份证</option>
							</select>
							<input type="text" name="" placeholder="证件号码" v-model="IDNumber"/>
						</div>
					</div>
				</div>

                <div class="ticket-bc-text" v-if="GoodsType==1">
                    <div class="ticket-bc-post-title">填写收件人信息</div>
                    <div class="ticket-bct-item">
                        <label>姓名</label>
                        <div>
                            <input type="text" name="" placeholder="需与证件保持一致" v-model="Recipients" />
                        </div>
                    </div>
                    <div class="ticket-bct-item" >
                        <label>手机号码</label>
                        <div>
                            <input type="text" name="" placeholder="接收取票短信凭证" v-model="ContactNumber" />
                        </div>
                    </div>
                    <div class="ticket-bct-item" >
                        <label>地址</label>
                        <div>
                            <input type="text" name=""  placeholder="" v-model="Address" />
                        </div>
                    </div>
                    <div class="ticket-bct-item">
                        <label>邮编</label>
                        <div>
                            <input type="text" name="" placeholder="" v-model="Postcode" />
                        </div>
                    </div>
                </div>

                <div class="ticket-bc-text" v-if="!isOnlyOneNeed">
                    <div class="ticket-bc-post-title" v-if="Guests&&Guests.length>0">填写游玩人信息</div>
                    <div v-for="(item,key) in Guests">
                        <label>游玩人{{key+2}}</label>
                        <div class="ticket-bct-item" v-if="ticketBookInfo.TravellerName==2">
                            <label>姓名</label>
                            <div>
                                <input type="text" name="" placeholder="需与证件保持一致" v-model="item.CnName"/>
                            </div>
                        </div>
                        <div class="ticket-bct-item" v-if="ticketBookInfo.TravellerEnName==2">
                            <label>英文名</label>
                            <div>
                                <input type="text" name="" placeholder="英文名称" v-model="item.FirstName" />
                            </div>
                        </div>
                        <div class="ticket-bct-item"  v-if="ticketBookInfo.TravellerMobile==2">
                            <label>手机号</label>
                            <div>
                                <input type="text" name=""  placeholder="接收取票短信凭证" v-model="item.Phone"/>
                            </div>
                        </div>
                        <div class="ticket-bct-item" v-if="ticketBookInfo.TravellerEmail==2">
                            <label>E-mail</label>
                            <div>
                                <input type="text" name=""  placeholder="邮箱" v-model="item.Email" />
                            </div>
                        </div>
                        <div class="ticket-bct-item" v-if="ticketBookInfo.TravellerCredentials==2">
                            <label>*证件类型</label>
                            <div>
                                <select>
                                    <option>身份证</option>
                                </select>
                                <input type="text" name=""  placeholder="用于景区入园等凭证" v-model="item.CardNumber"/>
                            </div>
                        </div>
                    </div>
  
                </div>



			</div>
		</div>
		<div class="ticket-book-submit">
			<div class="ticket-book-submit-total">
				<label>门票总价：</label>
				<span v-if="mySelect">¥{{mySelect.Price*stock}} </span>
				<div class="ticket-book-submit-btn" @click="review" v-if="!isSubmit">
					去付款
				</div>
                <div class="ticket-book-submit-btn disabled" v-else>
                    提交订单中...
                </div>
			</div>
		</div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false"></Modal>
        <BookReview v-if="bookReviewShow" @ok="check" @cancel="bookReviewShow=false" :info="bookReviewInfo" ></BookReview>
	</div>
</template>
<script>
    import DailyData from './dailyData.vue'//价格日历
    import Rull from './../bookNotice/rull.vue'//安全需知
    import BookReview from './bookReview.vue'//下单预览
    import Modal from './../../../common/cmpnt/Modal/modal.vue'//跳转提示框
	export default{
		name:"ticket-book",
        components: {
            DailyData,
            Rull,
            BookReview,
            Modal
        },
		data(){
			return {
				ticketBookInfo:this.dao.get('ticketBookInfo'),
				userInfo:this.dao.get('userInfo'),
				FirstName:'',
                LastName:'',
                Phone:'',
                Email:'',
                CertificateType:this.dao.get('ticketBookInfo').TravellerCredentials>0?1:'',
                IDNumber:'',
                Address:'',
                Postcode:'',
                stock:1,
                mySelect:'',
                mySelectIndex:'',
                GoodsType:this.dao.get('ticketBookInfo').GoodsType,
                list:'',
                PickUpPhone:'',
                PickUpName:'',
                PickUpEmail:'',
                Recipients:'',
                ContactNumber:'',
                Guests:[],
                dailyData:[],
                isDateShow:false,
                isTicketInfoShow:false,
                isOnlyOneNeed:false,
                isRullShow:false,
                isSubmit:false,//是否正在提交订单
                codeImg:'',
                captcha:'',
                CaptchaCode:'',
                bookReviewShow:false,
                bookReviewInfo:{},
                modal:{
                    show:false,
                    config:{}
                },

			}
		},
		methods:{ 
			toBookNotice(){

			},
           //票数减1
            minus(){
                if(this.stock==1||!this.mySelect)return;
                this.Guests.pop();
                this.stock-=1;
            },
             //票数加1
            plus(){
                if(!this.mySelect){
                    this.error({title:'提示',content:'请先选择日期'});
                    return;
                }
                var maxNum= this.ticketBookInfo.Maximum-this.mySelect.Stock>0?this.mySelect.Stock:this.ticketBookInfo.Maximum;
                if(this.stock>=maxNum||!this.mySelect){
                    this.error({title:'提示',content:'库存不足'});
                    return;
                }
                this.stock+=1;
                if(this.isOnlyOneNeed)return;
                var item={'FirstName':'','LastName':'','Age':'','Phone':'','CardNumber':'','CardType':this.ticketBookInfo.TravellerCredentialsType>1?1:'','Email':'','CnName':''};
                this.Guests.push(item)
                
            
            },
            //选择其它日期的价格
            selectday(index){
                this.mySelect=this.dailyData[index];
                this.stock=1;
                this.initialGuestsInfo();
                this.isDateShow=false;
            },
            // 是否只需要录入一位游客信息
            getIsOnlyOneNeed(){
                 var ticketBookInfo=this.ticketBookInfo;
                return !(ticketBookInfo.TravellerName==2||
                        ticketBookInfo.TravellerMobile==2||
                        ticketBookInfo.TravellerEnName==2||
                        ticketBookInfo.TravellerEmail==2||
                        ticketBookInfo.TravellerCredentials==2)
            },
            //初始化游客数量
            initialGuestsInfo(){
                if(this.isOnlyOneNeed)return;//如果只需要录入一位游客信息，则不需要初始化游客数量
                var totalGuests=this.ticketBookInfo.AdultTicket+this.ticketBookInfo.ChildTicket;
            
                var that=this;
                var stock=this.stock*totalGuests;
                var arr=[];
              
                for(var i=0;i<stock-1;i++){
                    var item={'FirstName':'','LastName':'','Age':'','Phone':'','CardNumber':'','CardType':this.ticketBookInfo.TravellerCredentialsType>1?1:'','Email':'','CnName':''};
                    if(i>=0&&that.isOnlyOneNeed)return;
                    arr.push(item);
                }
                that.$nextTick(function () {
                    that.Guests=arr;
                })
                
            },
            select(item,index){
                 this.stock=1;
                if(!item.CanBooking){
                    this.mySelectIndex=-1;
                    this.mySelect='';
                    return;
                }
                this.mySelect=item;
                this.mySelectIndex=index;
              
            },
            //获取门票价格日历 
            getTicketDaily(){
                var that=this;
                var params={
                    HotelID:this.ticketBookInfo.ScenicId,
                    RoomID:this.ticketBookInfo.TicketId,
                    StartDate:this.getDate(0),
                }
                that.postRequest({
                    url: that.Api.getticketDaily,
                    params:params
                   
                }).then(res => {
                    if (res&&res.IsSuccess) {
                        if(res.Result&&res.Result.length>2){
                            that.list=res.Result.slice(0,3);
                        }else{
                            that.list=res.Result;
                        }
                        
                        that.dailyData=res.Result;
                    } else {
                        that.list='';
                    }
                });
            },
            //获取图片验证码
            getCaptcha(){
                var that = this;
                var params = {
                    width:'300',
                    height:'200'
                }
                that.getRequest({
                    url: that.Api.captcha,
                    params: params
                }).then(res => {
                    
                    that.codeImg= 'data:image/jpg;base64,'+res.Img;
                    that.captcha=res;
                    // if (res && res.IsSuccess) {
                    //     that.keyResult = res.Result;
                    // }
                });
            },
            //获取天数差
            getDaysSize(s2){
                var s1 = new Date(this.getDate(0));
                var s2 = new Date(s2);

                var days = s2.getTime() - s1.getTime();
                var time = parseInt(days / (1000 * 60 * 60 * 24));
                return time;
            },
            //获取门票可订信息
            getTicketTimeLimit(time){
                var str='';
                var ts=this.getDaysSize(time);//时间天数差

                var da = new Date(time);
                var hour = da.getHours()<10?('0'+da.getHours()):da.getHours();
                var minutes = da.getMinutes()<10?('0'+da.getMinutes()):da.getMinutes();
                var thisTime=hour+':'+minutes;

                if(ts==0&&thisTime=='23:59'){
                    return '随买随用'
                }
                if(ts==0&&thisTime!='23:59'){
                    return thisTime+'前可定今日票'
                }
                if(ts>0){
                    return '需提前'+ts+'天'+thisTime+'前订票'
                }


            },


            //1.门票可订检查
            check(){
                var that=this;
                var params={
                    Token  :this.mySelect.Token,
                    Count:this.stock,
                }
                that.modal={
                    show:true,
                    content:'正在为您核对门票库存信息，请稍后....',
                }
                that.isSubmit=true;
                that.postRequest({
                    url: that.Api.checkTicket,
                    params:params
                   
                }).then(res => {
                    that.modal.show=false;
                    if (res&&res.IsSuccess) {
                        that.checkAccount(res.Result.Token);
                    } else {
                        that.error({title:'提示',content:res.Msg});
                        that.isSubmit=false;
                    }
                });
            },

            //2.查询是否有额度，有的话直接下单，
            checkAccount(token){
                var that=this;
                var params={
                    Token:token,
                }
                that.modal={
                    show:true,
                    content:'正在为您检查结算方式和信贷额度，请稍后..',
                }
                that.postRequest({
                    url: that.Api.checkAccount,
                    params: params
                }).then(res => {
                    that.modal.show=false;
                    if (res&&res.IsSuccess) {
                       that.book(true)
                    } else {
                       that.book(false)
                    }
                });
            },
            //3.门票下单
            book(UseCreditAccount){
                var that=this;
           
                var params={
                    Token:this.mySelect.Token,
                    Count:this.stock,
                    Guests:this.Guests&&this.Guests.length>0?this.Guests:null,
                    PickUpPhone:this.PickUpPhone,
                    PickUpName:this.PickUpName,
                    PickUpEmail:this.PickUpEmail,
                    FirstName:this.FirstName,
                    LastName:this.LastName,
                    Recipients:this.Recipients,
                    CertificateType:this.CertificateType,
                    IDNumber:this.IDNumber,
                    ContactNumber:this.ContactNumber,
                    Address:this.Address,
                    Postcode:this.Postcode,
                    CaptchaCode:this.CaptchaCode,
                    CaptchaToken:this.captcha.Token,
                    CaptchaTrackeKey:this.captcha.TraceKey,
                    UseCreditAccount:UseCreditAccount
                }
              
         
                that.isSubmit=true;
                that.modal={
                    show:true,
                    content:'正在为您提交订单，请稍后...',
                }
                that.postRequest({
                    url: that.Api.createTicket,
                    params:params
                }).then(res => {
                   
                    that.isSubmit=false;
                    that.modal.show=false;

                    if (res&&res.IsSuccess) {
                        if(UseCreditAccount){
                            that.$router.push('/ticketBookComplete?OrderNO='+res.Result.MainOrderID);
                        }else{
                            that.$router.push('/ticketBookComfirm?OrderNO='+res.Result.MainOrderID);
                        }
                    } else {
                        this.error({title:'提示',content:res.Msg});
                        this.getCaptcha();
                    }
                });
            },
            //输入数据验证,并预览
            review(){
                var that=this;
                if(this.isSubmit)return;
                if(!this.mySelect.CanBooking){
                     this.error({title:'提示',content:'当前日期不可预订'});
                }
                var str='';
                str=!this.PickUpName?'请输入取票人姓名':(!this.PickUpPhone?'请输入取票人手机号':'');

                if(!this.mySelect.Token){
                    this.error({title:'提示',content:'请选择游玩日期'});
                    return;
                }
                if(str){
                    this.error({title:'提示',content:str});
                    return;
                }
                var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");

                if(!this.checkMobile(this.PickUpPhone))return; 
                if(!reg.test(this.PickUpEmail)&&this.ticketBookInfo.TravellerEmail>0){
                   this.error({title:'提示',content:'邮箱地址格式出错'});
                   return; 
                }
                if(!this.IDNumber&&this.ticketBookInfo.TravellerCredentials>0){
                   this.error({title:'提示',content:'请输入居民身份证号码'});
                   return; 
                }
                if(!this.CaptchaCode){
                    this.error({title:'提示',content:'请输入验证码'});
                    return;
                }

                var mySelect=this.mySelect;
                var Guests=this.Guests;
                var stock=this.stock;
                var PickUpName=this.PickUpName;

                this.bookReviewInfo={mySelect,Guests,stock,PickUpName}
                this.bookReviewShow=true;

            }
		},
		mounted(){
            this.getTicketDaily();
            this.getCaptcha();
            this.initialGuestsInfo();
            this.isOnlyOneNeed=this.getIsOnlyOneNeed();//是否只需要录入一位游客信息
            this.PickUpPhone=this.userInfo.Phone;

          
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/ticket/book/book.vue